/**
 * Component Alignement
 */
export var Alignable;
(function (Alignable) {
    Alignable["ALIGNED_CENTER"] = "ALIGNED_CENTER";
    Alignable["ALIGNED_START"] = "ALIGNED_START";
    Alignable["ALIGNED_END"] = "ALIGNED_END";
})(Alignable || (Alignable = {}));
/**
 * Returns alignement classname depending on align type
 * @param alignType {Alignable|string} - Alert type
 * @returns {string} - Align value
 */
export var getAlignClassName = function (alignType) {
    switch (alignType) {
        case 'ALIGNED_CENTER':
            return 'aligned-center';
        case 'ALIGNED_START':
            return 'aligned-start';
        case 'ALIGNED_END':
            return 'aligned-end';
        default:
            return 'aligned-start';
    }
};
/**
 * Returns alignement classname depending on align type
 * @param alignType {Alignable|string} - Align type
 * @returns {string} - Align value
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export var getAlignStyle = function (alignType) {
    switch (alignType) {
        case 'ALIGNED_CENTER':
            return 'center';
        case 'ALIGNED_START':
            return 'flex-start';
        case 'ALIGNED_END':
            return 'flex-end';
        default:
            return 'flex-start';
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQWxpZ25hYmxlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vb2JqZWN0cy9mYWNldHMvQWxpZ25hYmxlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBOztHQUVHO0FBQ0gsTUFBTSxDQUFOLElBQVksU0FJWDtBQUpELFdBQVksU0FBUztJQUNuQiw4Q0FBaUMsQ0FBQTtJQUNqQyw0Q0FBK0IsQ0FBQTtJQUMvQix3Q0FBMkIsQ0FBQTtBQUM3QixDQUFDLEVBSlcsU0FBUyxLQUFULFNBQVMsUUFJcEI7QUFTRDs7OztHQUlHO0FBQ0gsTUFBTSxDQUFDLElBQU0saUJBQWlCLEdBQUcsVUFBQyxTQUFrQjtJQUNsRCxRQUFRLFNBQVMsRUFBRTtRQUNqQixLQUFLLGdCQUFnQjtZQUNuQixPQUFPLGdCQUFnQixDQUFBO1FBQ3pCLEtBQUssZUFBZTtZQUNsQixPQUFPLGVBQWUsQ0FBQTtRQUN4QixLQUFLLGFBQWE7WUFDaEIsT0FBTyxhQUFhLENBQUE7UUFDdEI7WUFDRSxPQUFPLGVBQWUsQ0FBQTtLQUN6QjtBQUNILENBQUMsQ0FBQTtBQUVEOzs7O0dBSUc7QUFDSCw2RUFBNkU7QUFDN0UsTUFBTSxDQUFDLElBQU0sYUFBYSxHQUFHLFVBQUMsU0FBa0I7SUFDOUMsUUFBUSxTQUFTLEVBQUU7UUFDakIsS0FBSyxnQkFBZ0I7WUFDbkIsT0FBTyxRQUFRLENBQUE7UUFDakIsS0FBSyxlQUFlO1lBQ2xCLE9BQU8sWUFBWSxDQUFBO1FBQ3JCLEtBQUssYUFBYTtZQUNoQixPQUFPLFVBQVUsQ0FBQTtRQUNuQjtZQUNFLE9BQU8sWUFBWSxDQUFBO0tBQ3RCO0FBQ0gsQ0FBQyxDQUFBIn0=